import { isNumberString } from "@corca/core";

import type { SuggestionProvider, Suggestion } from "@/components/suggestions/types";

function isScientificNumberNotation(str: string) {
  return str.includes("e") || str.includes("E");
}

export const numberSuggestionsProvider: SuggestionProvider = {
  type: "input",
  search: (str) => {
    const options: Suggestion[] = [];

    if (isNumberString(str)) {
      const numberInputSuggestion: Suggestion = {
        type: "single",
        item: {
          type: "number",
          intlName: "number",
          symbol: str,
        },
        priority: 4,
        hideStandalone: !isScientificNumberNotation(str),
        canBeAutocompleted: true,
      };

      options.push(numberInputSuggestion);
    } else if (isNumberString(`${str}0`) && isScientificNumberNotation(`${str}0`)) {
      const numberInputSuggestion: Suggestion = {
        type: "single",
        item: {
          type: "number",
          intlName: "number",
          symbol: `${str}0`,
        },
        priority: 4,
        hideStandalone: !isScientificNumberNotation(str),
        canBeAutocompleted: true,
      };

      options.push(numberInputSuggestion);
    }

    return [options];
  },
};
